window.addEventListener('scroll', function () {
    const modal = document.getElementById('modal_st');
      const header = document.getElementById('header_open_st');
        const scrolled = window.scrollY > 100; // <-- increased threshold
          const isMobile = window.innerWidth <= 768; // adjust breakpoint if needed

            // #modal_st: visible at top, hidden on scroll (only on mobile)
              if (modal) {
                  if (isMobile) {
                        modal.style.visibility = scrolled ? 'hidden' : 'visible';
                            } else {
                                  modal.style.visibility = 'visible'; // always visible on desktop
                                      }
                                        }

                                          // #header_open_st: hidden at top, visible on scroll (on all devices)
                                            if (header) {
                                                header.style.visibility = scrolled ? 'visible' : 'hidden';
                                                  }
                                                  });


document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.apps');

  const fixedText = 'Search for ';
  const words = ['Bleuface…','Sunscreen…', 'Maybelline…', 'Loreal…', 'Bioaqua…', 'Garnier…', 'Sheglam…'];

  const typingSpeed = 80;
  const deletingSpeed = 40;
  const pauseTime = 1500;

  elements.forEach((el) => {
    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function loop() {
      const currentWord = words[wordIndex];

      if (!isDeleting) {
        charIndex++;
        el.textContent = fixedText + currentWord.substring(0, charIndex);

        if (charIndex === currentWord.length) {
          isDeleting = true;
          setTimeout(loop, pauseTime);
          return;
        }
      } else {
        charIndex--;
        el.textContent = fixedText + currentWord.substring(0, charIndex);

        if (charIndex === 0) {
          isDeleting = false;
          wordIndex = (wordIndex + 1) % words.length;
        }
      }

      setTimeout(loop, isDeleting ? deletingSpeed : typingSpeed);
    }

    // start
    el.textContent = fixedText;
    loop();
  });
});



